import React, { useEffect, useState } from 'react'

import axios from '../../utils/axios'
import useAuth from '../../context/hook/useAuth'
import { site } from '../../utils/SiteSettings'



export const Token = () => {

    const {user} = useAuth()

    const [token, setToken] = useState([])

    const tokenCheck = async () => {
        try {
            await axios.get(`/token/detail`,
                {
                    headers:{
                        "Content-Type": "application/json",
                        "Authorization":user
                    },
                    withCredentials:true,
                }
            ).then((res)=>{
                let data = JSON.parse(res.data)
                // console.log(data)
                setToken(data)
            }).catch(err=>{
                console.log(err)
            })
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(()=>{
        tokenCheck()
        // eslint-disable-next-line
    },[])

  return (
    <div>
        <div className="wallet-history">
            <div className="table-responsive">
                <table className="table">
                    <thead>
                    <tr>
                        <th scope="col">Date &amp; Time</th>
                        {/* <th scope="col">Address</th> */}
                        {/* <th scope="col">Transaction Id</th> */}
                        <th scope="col" >Type</th>
                        <th scope="col">Coin</th>
                        <th scope="col">Pay</th>
                        <th scope="col">Total Buy Token</th>
                        <th scope="col">Fee({site.siteName})</th>
                        <th scope="col">Received</th>
                        <th scope="col">Status</th>
                    </tr>
                    </thead>
                    <tbody>
                        {
                            token&&token.map((item,index)=>{
                                return(
                                    <React.Fragment key={index}>
                                        <tr key={index}>
                                            <td>{item.Time}</td>
                                            {/* <td>{item.Transfer_To}</td>
                                            <td>{item.Transaction_ID}</td> */}
                                            <td>{item.Type}</td>
                                            <td>{item.Pair_Name}</td> 
                                            <td>{item.Price}</td>
                                            <td>{(item.Token_Fee+item.Amount)?.toFixed(5)}</td>
                                            <td>{item.Token_Fee}</td>
                                            <td>{item.Amount?.toFixed(4)}</td>
                                            {/* <td  className={item.Status ==="Approved" ? "clr-green" : item.Status ==="Rejected" ? "clr-red" : '' }>{item.Status == 'Not Approval' ? "Pending" : item.Status }</td> */}
                                            <td className='clr-green'>Completed</td>
                                        </tr>
                                    </React.Fragment>
                                )
                            })
                        }
                    </tbody>
                </table>
            </div>
        </div>
    </div>
  )
}
